import { useEffect, useState } from "react";
import { useControllerContext } from "../../hooks/controller-context";
import {
  BlindUpSelect,
  ControllerTimerCircle,
  ControllerTournamentBlindWrapper,
  ControllerTournamentCircleButtonWrapper,
  ControllerTournamentCircleTextWrapper,
  ControllerTournamentCircleWrapper,
  ControllerTournamentSoundItem,
  ControllerTournamentInfoBoxWrapper,
  ControllerTournamentInfoNotice,
  ControllerTournamentInfoWrapper,
  ControllerTournamentInputWrapper,
  ControllerTournamentSoundWrapper,
  ControllerTournamentTimeButtonWrapper,
  ControllerTournamentTimeUpdate,
  ControllerTournamentTimeUpdateWrapper,
  ControllerTournamentToggleCircle,
  ControllerTournamentToggleItem,
} from "./style";
import {
  TimerControllerBox,
  TimerControllerInputBox,
  TimerControllerBackgroundBox,
} from "../../style";
import { updateTournamentNotice } from "../../../../api/tournament";
import { useTournamentLevel } from "./hooks/use-tournament-level";
import { useTournamentTimer } from "./hooks/use-tournament-timer";
import { isTournamentAccess } from "../../../../utils/owner";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../../recoil/pub.atom";

const TimerControllerTournamentInfo = () => {
  // 레벨 이동 관련
  const {
    levelInput,
    setLevelInput,
    handleFirstLevel,
    handleLastLevel,
    handleLevel,
    handleUpdateLevel,
    getLevelText,
  } = useTournamentLevel();

  // 시간 이동 관련
  const {
    now_level_time_radius,
    circumference,
    calculateStrokeDashoffset,
    handleUpdateTime,
    handleCircleClick,
  } = useTournamentTimer();

  // 사운드 관련
  const {
    data,
    getData,
    countdownActive,
    setCountdownActive,
    upSound,
    setUpSound,
    playSound,
    timeInfo,
    updateTotalStack,
    isTtsPlaying,
    setIsTtsPlaying,
  } = useControllerContext();
  const pub = useRecoilValue(pubState);

  // input 관련
  const [totalStackInput, setTotalStackInput] = useState(0);
  const [timeInput, setTimeInput] = useState(0);
  const [notice, setNotice] = useState("");

  // 광고 음소거
  const [isMuted, setIsMuted] = useState<boolean>(true);

  useEffect(() => {
    const adSound = localStorage.getItem("ad-sound");
    if (!adSound) {
      localStorage.setItem("ad-sound", "true");
      setIsMuted(true);
      return;
    }
    const isMuted = adSound === "true";
    setIsMuted(isMuted);
  }, []);

  useEffect(() => {
    if (data?.notice) setNotice(data.notice);
  }, [data?.notice]);

  // 공지사항 수정
  const handleUpdateNotice = async () => {
    if (!data) return;
    if (!isTournamentAccess(data.id, pub?.tournamentIds)) {
      alert(`토너먼트 ID ${data.id}에 대한 권한이 없습니다. `);
      return;
    }

    try {
      await updateTournamentNotice(data.id, { notice });
      await getData();
    } catch (e: any) {
      console.error(e);
      if (e.status === 403) {
        alert(e.response.data.message);
        return;
      }
    }
  };

  const soundList = [
    { name: "블라인드 업1", value: 0 },
    { name: "블라인드 업2", value: 1 },
    { name: "레벨 업1", value: 2 },
    { name: "레벨 업2", value: 3 },
  ];

  return (
    <ControllerTournamentInfoWrapper>
      <ControllerTournamentInfoBoxWrapper flex={0.85}>
        <TimerControllerBackgroundBox>
          <div className="title">공지사항</div>
          <ControllerTournamentInfoNotice>
            <TimerControllerInputBox height="100%">
              <textarea
                value={notice}
                onChange={(e) => setNotice(e.target.value)}
                placeholder="공지사항을 입력해주세요. "
              />
            </TimerControllerInputBox>
            <div className="button" onClick={handleUpdateNotice}>
              저장
            </div>
          </ControllerTournamentInfoNotice>
        </TimerControllerBackgroundBox>
        <TimerControllerBackgroundBox height="202px">
          <div className="title">TOTAL STACK 조정</div>
          <ControllerTournamentInputWrapper>
            <img
              src="/image-web/controller/minus.svg"
              alt="minus"
              onClick={() => {
                updateTotalStack(-totalStackInput);
                setTotalStackInput(0);
              }}
            />
            <TimerControllerInputBox height="64px">
              <input
                value={totalStackInput ? totalStackInput.toLocaleString() : ""}
                onChange={(e) => {
                  const rawValue = e.target.value.replace(/[^0-9]/g, "");
                  const value = parseInt(rawValue, 10) || 0;
                  setTotalStackInput(value);
                }}
                placeholder="조절할 TOTAL STACK 입력"
              />
            </TimerControllerInputBox>
            <img
              src="/image-web/controller/plus.svg"
              alt="plus"
              onClick={() => {
                updateTotalStack(+totalStackInput);
                setTotalStackInput(0);
              }}
            />
          </ControllerTournamentInputWrapper>
        </TimerControllerBackgroundBox>
      </ControllerTournamentInfoBoxWrapper>
      <ControllerTournamentInfoBoxWrapper flex={1}>
        <TimerControllerBackgroundBox height="280px">
          <div className="title">레벨 이동</div>
          <ControllerTournamentInputWrapper>
            <img
              src="/image-web/controller/first.svg"
              alt="first"
              onClick={handleFirstLevel}
            />
            <img
              src="/image-web/controller/minus.svg"
              alt="minus"
              onClick={() => handleUpdateLevel(-1)}
            />
            <div className="level">{getLevelText()}</div>
            <img
              src="/image-web/controller/plus.svg"
              alt="plus"
              onClick={() => handleUpdateLevel(1)}
            />
            <img
              src="/image-web/controller/last.svg"
              alt="last"
              onClick={handleLastLevel}
            />
          </ControllerTournamentInputWrapper>
          <ControllerTournamentInputWrapper>
            <TimerControllerInputBox height="64px">
              <input
                value={!levelInput ? "" : levelInput}
                onChange={(e) => setLevelInput(+e.target.value)}
                placeholder="이동할 레벨 입력"
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleLevel();
                }}
              />
            </TimerControllerInputBox>
            <div className="button" onClick={handleLevel}>
              레벨 이동
            </div>
          </ControllerTournamentInputWrapper>
        </TimerControllerBackgroundBox>
        <TimerControllerBackgroundBox>
          <div className="title">소리 조절</div>
          <ControllerTournamentSoundWrapper>
            <ControllerTournamentSoundItem>
              <div className="name">카운트 다운</div>
              <ControllerTournamentToggleItem
                isOn={countdownActive}
                onClick={() => {
                  localStorage.setItem(
                    "countdown-sound",
                    !countdownActive ? "true" : "false",
                  );
                  setCountdownActive(!countdownActive);
                }}
              >
                <ControllerTournamentToggleCircle isOn={countdownActive} />
              </ControllerTournamentToggleItem>
            </ControllerTournamentSoundItem>
            <ControllerTournamentSoundItem>
              <div className="name">레벨 정보 읽어주기</div>
              <ControllerTournamentToggleItem
                isOn={isTtsPlaying}
                onClick={() => {
                  localStorage.setItem(
                    "tts-sound",
                    isTtsPlaying ? "false" : "true",
                  );
                  setIsTtsPlaying(!isTtsPlaying);
                }}
              >
                <ControllerTournamentToggleCircle isOn={isTtsPlaying} />
              </ControllerTournamentToggleItem>
            </ControllerTournamentSoundItem>
            <ControllerTournamentSoundItem>
              <div className="name">BRAKE 광고 음소거</div>
              <ControllerTournamentToggleItem
                isOn={isMuted}
                onClick={() => {
                  localStorage.setItem("ad-sound", isMuted ? "false" : "true");
                  setIsMuted(!isMuted);
                }}
              >
                <ControllerTournamentToggleCircle isOn={isMuted} />
              </ControllerTournamentToggleItem>
            </ControllerTournamentSoundItem>
            <ControllerTournamentSoundItem>
              <div className="name">블라인드 업</div>
              <ControllerTournamentToggleItem
                isOn={upSound !== null}
                onClick={() => {
                  localStorage.setItem(
                    "blind-up-sound",
                    upSound === null ? "0" : "null",
                  );
                  setUpSound(upSound === null ? 0 : null);
                }}
              >
                <ControllerTournamentToggleCircle isOn={upSound !== null} />
              </ControllerTournamentToggleItem>
            </ControllerTournamentSoundItem>
            <ControllerTournamentBlindWrapper>
              {soundList.map((sound, index) => (
                <BlindUpSelect
                  key={index}
                  isSelected={upSound === sound.value}
                  onClick={() => {
                    localStorage.setItem(
                      "blind-up-sound",
                      sound.value.toString(),
                    );
                    setUpSound(sound.value);
                    if (sound.value) playSound(sound.value);
                  }}
                >
                  {sound.name}
                </BlindUpSelect>
              ))}
            </ControllerTournamentBlindWrapper>
          </ControllerTournamentSoundWrapper>
        </TimerControllerBackgroundBox>
      </ControllerTournamentInfoBoxWrapper>
      <ControllerTournamentInfoBoxWrapper>
        <TimerControllerBackgroundBox>
          <ControllerTournamentCircleWrapper>
            <ControllerTournamentCircleTextWrapper>
              <div className="title">
                {timeInfo.elapsedTimeMs && timeInfo.elapsedTimeMs > 0
                  ? "현재 레벨 남은 시간 조정"
                  : "시작까지 남은 시간"}
              </div>
              <div className="time">{timeInfo.remainingTimeInCurrentLevel}</div>
            </ControllerTournamentCircleTextWrapper>
            <ControllerTournamentCircleButtonWrapper>
              <div
                className="button"
                onClick={() => {
                  handleUpdateTime(0, true);
                }}
              >
                <img src="/image-web/controller/stop.svg" alt="stop" />
              </div>
              <div className="name">정지</div>
            </ControllerTournamentCircleButtonWrapper>
            <ControllerTimerCircle viewBox="0 0 400 400">
              <defs>
                <radialGradient id="gradient" cx="65%" cy="80%" r="80%">
                  <stop offset="0%" stopColor="#FFFFFF" />
                  <stop offset="100%" stopColor="#7012CE" />
                </radialGradient>
              </defs>
              <circle
                onClick={handleCircleClick}
                className="background"
                r={now_level_time_radius}
                cx="200"
                cy="200"
              />
              <circle
                onClick={handleCircleClick}
                className="progress"
                r={now_level_time_radius}
                cx="200"
                cy="200"
                stroke="url(#gradient)"
                strokeDasharray={circumference}
                strokeDashoffset={calculateStrokeDashoffset()}
                style={{
                  transform: "rotate(-90deg)",
                  transformOrigin: "50% 50%",
                }}
              />
            </ControllerTimerCircle>
            <ControllerTournamentCircleButtonWrapper>
              <div
                className="button"
                onClick={() => {
                  handleUpdateTime(0, false);
                }}
              >
                <img src="/image-web/controller/start.svg" alt="start" />
              </div>
              <div className="name">재생</div>
            </ControllerTournamentCircleButtonWrapper>
          </ControllerTournamentCircleWrapper>
          <ControllerTournamentTimeUpdateWrapper>
            <ControllerTournamentTimeButtonWrapper isPlus={true} isWide={true}>
              <div className="second-box box">
                <div className="button" onClick={() => handleUpdateTime(-1000)}>
                  +1초
                </div>
              </div>
              <div className="minute-box box">
                <div
                  className="button"
                  onClick={() => handleUpdateTime(-60000)}
                >
                  +1분
                </div>
              </div>
            </ControllerTournamentTimeButtonWrapper>
            <TimerControllerBox width="347px" height="122px">
              <ControllerTournamentTimeUpdate>
                <div className="name">시간변경</div>
                <div className="wrapper">
                  <div
                    className="box plus-box"
                    onClick={() => {
                      handleUpdateTime(timeInput * 1000);
                      setTimeInput(0);
                    }}
                  >
                    추가
                  </div>
                  <div
                    className="box minus-box"
                    onClick={() => {
                      handleUpdateTime(-(timeInput * 1000));
                      setTimeInput(0);
                    }}
                  >
                    감소
                  </div>
                  <input
                    value={timeInput}
                    onChange={(e) => setTimeInput(+e.target.value)}
                    onClick={(e) => e.currentTarget.select()}
                  />
                </div>
              </ControllerTournamentTimeUpdate>
            </TimerControllerBox>
            <ControllerTournamentTimeButtonWrapper isPlus={false} isWide={true}>
              <div className="second-box box">
                <div className="button" onClick={() => handleUpdateTime(1000)}>
                  -1초
                </div>
              </div>
              <div className="minute-box box">
                <div className="button" onClick={() => handleUpdateTime(60000)}>
                  -1분
                </div>
              </div>
            </ControllerTournamentTimeButtonWrapper>
          </ControllerTournamentTimeUpdateWrapper>
        </TimerControllerBackgroundBox>
      </ControllerTournamentInfoBoxWrapper>
    </ControllerTournamentInfoWrapper>
  );
};

export default TimerControllerTournamentInfo;
